import { IGroupConfigurationData, IPharmacyORE } from "model/FlexibleAttributeModel";
import { BaseJsonTransformer } from "./IJsonTransformer";
import { ISaveInstruction } from "global/Application/dataActions";
import * as IXrmTypes from 'model/CRM';

export class UpgradeReleaseTransformer extends BaseJsonTransformer {
    readonly instructions?: ISaveInstruction;
    xSnapshot: IXrmTypes.bcbs_groupconfigurationsnapshot;
    snapshot: IXrmTypes.bcbs_groupconfigurationsnapshot;

    constructor(instructions: ISaveInstruction,
        xSnapshot: IXrmTypes.bcbs_groupconfigurationsnapshot,
        snapshot: IXrmTypes.bcbs_groupconfigurationsnapshot
    ) {
        super();
        this.instructions = instructions;
        this.xSnapshot = xSnapshot;
        this.snapshot = snapshot;
    }

    async before(json: IGroupConfigurationData): Promise<void> {

        if (this.snapshot.bcbs_groupconfigurationsnapshotid)
            json.id = this.snapshot.bcbs_groupconfigurationsnapshotid;

        if (this.snapshot.bcbs_name)
            json.name = this.snapshot.bcbs_name;

        if (this.snapshot.bcbs_groupconfigurationsnapshotid)
            json.comments.forEach(comment => {
                if (comment.location)
                    comment.location = {
                        ...comment.location,
                        snapshotId: this.snapshot.bcbs_groupconfigurationsnapshotid
                    }
            })
    }

}
